import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/finRep',
  component: layout,
  meta: {
    funcID: 'C0008',
    PID: 'C00',
  },
  children: ((pre) => [
    {
      path: 'budgetAnalysis',
      name: `${pre}budgetAnalysis`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000801',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finRep/budgetAnalysis'),
    },
    {
      path: 'personExpense',
      name: `${pre}personExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000802',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finRep/personExpense'),
    },
    {
      path: 'scmExpense',
      name: `${pre}scmExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000805',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finRep/scmExpense'),
    },
    {
      path: 'depExpense',
      name: `${pre}depExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000803',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finRep/depExpense'),
    },
    {
      path: 'custExpense',
      name: `${pre}custExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000804',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finRep/custExpense'),
    },
    {
      path: 'financialStatistics',
      name: `${pre}financialStatistics`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'C000806',
        PID: 'C00',
      },
      component: () => import('@/views/financial/finRep/financialStatistics'),
    },
  ])('financial-finRep-'),
}
